import './textInput.css';

const TextInputArea = ({ className, onChange, value, placeholder, rows = 4, id }) => {
    return <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`text-input-generic text-input-textarea ${className || ''}`}
        placeholder={placeholder}
        rows={rows}
    />;
};

export default TextInputArea;